import React, { Fragment } from "react";
import { IntlProvider } from "react-intl";
import AppLocale from "./translations";
import { useSelector } from "react-redux";

export const I18nProvider = ({ children }) => {
  const locale = useSelector(({theme})=> theme.locale)
  const defaultKey = Object.keys(AppLocale)[0];
  const currentAppLocale =
    AppLocale[locale] === undefined ? AppLocale[defaultKey] : AppLocale[locale];
  return (
    <IntlProvider
      locale={locale}
      textComponent={Fragment}
      messages={currentAppLocale}
    >
      {children}
    </IntlProvider>
  );
};
